import { Component, OnInit } from '@angular/core';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  login = true;
  appVersion!: string;

  ngOnInit(): void {
    this.appVersion = packageJson.version;
  }
}
